import {
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Stack,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import logo from "../../assets/logo.png";
import { Call } from "@mui/icons-material";

export const BlossomBoost = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [userFirstName, setUserFirstName] = useState("Teste");
  const [country, setCountry] = useState("br");
  // const [typeOfCall, setTypeOfCall] = useState("normal");
  const [leadType, setLeadType] = useState("bb_debt_collection_casual");
  const [testV2FacebookPageName, setTestV2FacebookPageName] = useState("Regularização Financeira");

  // const [numeroPlazasC1, setNumeroPlazasC1] = useState("32");
  // const [numeroPlazasC2, setNumeroPlazasC2] = useState("252");
  const cpfFirstThree = "123";
  const cpfLastTwo = "10";

  const handleSubmit = async (event) => {
    event.preventDefault();

    const fromNumber = "17273395810";
    const agentID = "agent_2de3a55968f69f8fccb02a78c6"
    const baseUrl =
      "https://initiateretellcall-655075094783.us-central1.run.app";

    const url = `${baseUrl}?lead_first_name=${userFirstName}&to_number=${phoneNumber}&from_number=${fromNumber}&agent_id=${agentID}&lead_type=${leadType}&cpf_first_three=${cpfFirstThree}&cpf_last_two=${cpfLastTwo}&company_name=${testV2FacebookPageName}`;

    console.log(`Starting call with URL ${url}`);

    await axios
      .request(url, {
        method: "GET",
        headers: {
          "ngrok-skip-browser-warning": "69420",
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => console.log(res));
  };

  return (
    <div className="full-page-background">
      <Grid item xs={12} md={7}>
        <Container className="App" maxWidth="sm">
          <img src={logo} className="App-logo" alt="logo" />
          <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
            <h1 style={{
              color: '#FFFFFF',
              fontSize: '2rem',
              fontWeight: 'bold',
              margin: '1rem',
            }}>
              Blossom Boost Demo
            </h1>
            <div style={{
              height: '4px',
              width: '100px',
              background: 'linear-gradient(90deg, #a0b8ff, #8a2be2)',
              margin: '0 auto',
              borderRadius: '2px'
            }}></div>
          </div>
          <h3 style={{
            textAlign: 'center',
            color: '#d0d0d0',
            fontWeight: '400',
            fontSize: '16px',
            lineHeight: '1.6',
            maxWidth: '500px',
            margin: '0 auto 1.5rem auto'
          }}>
            Agente de Regularização Financeira (Demonstração)
          </h3>
          <form onSubmit={handleSubmit}>
            <Stack spacing={2}>

              <>
                <Select
                  value={leadType}
                  onChange={(e) => {
                    setLeadType(e.target.value);
                  }}
                  required
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "4px",
                    textAlign: "left",
                  }}
                >
                  <MenuItem value="bb_debt_collection_casual">
                    Nível 1 - Tranquilo
                  </MenuItem>
                  <MenuItem value="bb_debt_collection_questioning">
                    Nível 2 - Questionador
                  </MenuItem>
                  <MenuItem value="bb_debt_collection_aggressive">
                    Nível 3 - Agressivo
                  </MenuItem>
                </Select>
                <TextField
                  label="Nome do devedor"
                  variant="filled"
                  sx={{
                    color: "white",
                    backgroundColor: "white",
                    borderRadius: "4px",
                  }}
                  fullWidth
                  // margin="normal"
                  value={userFirstName}
                  onChange={(e) => setUserFirstName(e.target.value)}
                  required
                />
                <TextField
                  label="Nome da empresa"
                  variant="filled"
                  sx={{
                    color: "white",
                    backgroundColor: "white",
                    borderRadius: "4px",
                  }}
                  fullWidth
                  // margin="normal"
                  value={testV2FacebookPageName}
                  onChange={(e) => setTestV2FacebookPageName(e.target.value)}
                  required
                />
              </>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <FormControl sx={{ flex: { sm: '0 0 25%' } }}>
                  <Select
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px",
                    }}
                    required
                  >
                    <MenuItem value="br">🇧🇷 (+55)</MenuItem>
                    <MenuItem value="ca">🇨🇦 (+1)</MenuItem>
                    <MenuItem value="us">🇺🇸 (+1)</MenuItem>
                  </Select>
                </FormControl>
                <Box sx={{ flex: { sm: '1' } }}>
                  <PhoneInput
                    country={country}
                    value={phoneNumber}
                    disableDropdown={true}
                    disableCountryGuess={true}
                    onChange={setPhoneNumber}
                    enableLongNumbers={true}
                    inputStyle={{
                      width: "100%",
                      textAlign: "center",
                      fontSize: "16px",
                      height: "56px",
                      borderRadius: "4px",
                      border: "1px solid #ced4da",
                    }}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px",
                    }}
                    required
                  />
                </Box>
              </Stack>
              <Button
                className="callBtn"
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  background: 'linear-gradient(45deg, #1976d2 30%, #2196f3 90%)',
                  boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
                  color: 'white',
                  height: '56px',
                  padding: '0 30px',
                  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 10px 4px rgba(33, 203, 243, .3)',
                    background: 'linear-gradient(45deg, #1769aa 30%, #1e88e5 90%)',
                  },
                }}
              >
                <h2 style={{ fontSize: "16px", fontWeight: "bold" }}>
                  Solicitar uma chamada de demonstração
                </h2>
                <div style={{ width: "20px" }} />
                <Call className="callIcon" />
              </Button>
              <div style={{
                // Bubble Container Styles
                backgroundColor: '#eaf2fa',
                padding: '16px',
                borderRadius: '8px',
                border: '1px solid #d0e0f0',

                // Flexbox for alignment
                display: 'flex',
                alignItems: 'center', // Vertically centers the icon and text
                gap: '12px'           // Adds space between the icon and text
              }}>
                {/* Icon */}
                <span style={{ fontSize: '24px' }}>ℹ️</span>

                <p style={{
                  margin: 0, // Resets default paragraph margin
                  textAlign: 'left',
                  color: '#333',
                  lineHeight: '1.5',
                  fontSize: '14px'
                }}>
                  O CPF usado para esta demonstração é:
                  <b style={{ color: '#005a9c' }}> 123.456.789-10</b>
                </p>
              </div>
              <div style={{
                // Bubble Container Styles
                backgroundColor: '#eaf2fa',
                padding: '16px',
                borderRadius: '8px',
                border: '1px solid #d0e0f0',
                
                // Flexbox for alignment
                display: 'flex',
                alignItems: 'center', // Vertically centers the icon and text
                gap: '12px'           // Adds space between the icon and text
              }}>
                {/* Icon */}
                <span style={{ fontSize: '24px' }}>ℹ️</span>

                {/* Text Content */}
                <p style={{
                  margin: 0, // Resets default paragraph margin
                  textAlign: 'left',
                  color: '#333',
                  lineHeight: '1.5',
                  fontSize: '14px'
                }}>
                  Após solicitar a chamada de demonstração, você receberá uma chamada
                  do seguinte número: 
                  <b style={{ color: '#005a9c' }}> +1(727)339-5810</b>
                </p>
              </div>
            </Stack>
          </form>
        </Container>
      </Grid>
    </div>
  );
};
